// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"04f1f3a9","350":"f3c08fd0","360":"f2ae547d","415":"382df6ca","445":"9d11256a","453":"e67b519e","455":"766972e6","536":"f04d3ab8","827":"cbf165f3","944":"0a0f5139","977":"2626d0aa","994":"2759427e"}[chunkId] + ".chunk.js";
};